var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-pin",
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,0C2.687,0,0,2.719,0,6.072c0,4.29,4.312,8.579,5.625,9.787C5.727,15.953,5.863,16,6,16s0.273-0.047,0.375-0.141     C7.688,14.651,12,10.362,12,6.072C12,2.719,9.313,0,6,0z M6,13.449c-2.085-2.154-4.023-4.99-4.023-7.377C1.977,3.827,3.781,2,6,2     s4.023,1.827,4.023,4.072C10.023,8.46,8.084,11.296,6,13.449z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.93711c14f528b8a6405e44b42610de5c.svg";
export { ForwardRef as ReactComponent };